/*
 *
 * AgencySelection constants
 *
 */

export const DEFAULT_ACTION = 'app/AgencySelection/DEFAULT_ACTION';
